import { Link } from "react-router-dom";

export default function NoEncontrado() {
  return (
    <div className="panel vacio">
      <h1>Esta página no existe</h1>
      <p className="muted">
        Puede que el enlace esté mal escrito o que la ficha ya no esté disponible.
      </p>
      <Link className="boton-primario" to="/">
        Ir a mis mascotas
      </Link>
    </div>
  );
}
